







































































import { Component, Prop, Watch } from "vue-property-decorator";
import EntityType from '@/models/Shared/EntityType';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import NoteDto from "@/models/Notes/NoteDto";
import CreateNoteRequest from "@/models/Notes/CreateNoteRequest";
import ListUtils from "@/lib/listUtils";
import NoteCategoryDto from "@/models/NoteCategories/NoteCategoryDto";
import NoteType from "@/models/Notes/NoteType";


@Component({
  name: "NoteCreate",
})
export default class extends GiganautVueDialog {
  
  @Prop({required: true})
  entityType: EntityType;
  entity: NoteDto = new NoteDto();
  public dialog = false;
  noteCategories: NoteCategoryDto[] = [];
  type: NoteType;

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new NoteDto();
    }
  }

  @Watch("entity.type")
  async onNoteTypeChanged(val: NoteType, oldVal: NoteType) {
    this.noteCategories = [];
    this.entity.noteCategory = null;
    this.entity.noteCategoryId = null;
    switch (this.entityType){
      case EntityType.Worker:
        for (let i = 0; i < WorkerDetailsModule.noteCategories.length; i++) {
          const noteCategory = WorkerDetailsModule.noteCategories[i];
            if (val == NoteType.General) {
              if (noteCategory.isEnabledOnWorkerGeneral) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Call) {
              if (noteCategory.isEnabledOnWorkerCall) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Meeting) {
              if (noteCategory.isEnabledOnWorkerMeeting) {
                this.noteCategories.push(noteCategory);
              }
            }
        }
        break;
      case EntityType.Company:
        for (let i = 0; i < CompanyDetailsModule.noteCategories.length; i++) {
          const noteCategory = CompanyDetailsModule.noteCategories[i];
            if (val == NoteType.General) {
              if (noteCategory.isEnabledOnCompanyGeneral) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Call) {
              if (noteCategory.isEnabledOnCompanyCall) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Meeting) {
              if (noteCategory.isEnabledOnCompanyMeeting) {
                this.noteCategories.push(noteCategory);
              }
            }
        }
          break;
      case EntityType.Contact:
        for (let i = 0; i < ContactDetailsModule.noteCategories.length; i++) {
          const noteCategory = ContactDetailsModule.noteCategories[i];
            if (val == NoteType.General) {
              if (noteCategory.isEnabledOnContactGeneral) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Call) {
              if (noteCategory.isEnabledOnContactCall) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Meeting) {
              if (noteCategory.isEnabledOnContactMeeting) {
                this.noteCategories.push(noteCategory);
              }
            }
        }
          break;
      case EntityType.Location:
        for (let i = 0; i < LocationDetailsModule.noteCategories.length; i++) {
          const noteCategory = LocationDetailsModule.noteCategories[i];
            if (val == NoteType.General) {
              if (noteCategory.isEnabledOnLocationGeneral) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Call) {
              if (noteCategory.isEnabledOnLocationCall) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Meeting) {
              if (noteCategory.isEnabledOnLocationMeeting) {
                this.noteCategories.push(noteCategory);
              }
            }
        }
          break;
      case EntityType.Campaign:
        for (let i = 0; i < CampaignDetailsModule.noteCategories.length; i++) {
          const noteCategory = CampaignDetailsModule.noteCategories[i];
            if (val == NoteType.General) {
              if (noteCategory.isEnabledOnCampaignGeneral) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Call) {
              if (noteCategory.isEnabledOnCampaignCall) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Meeting) {
              if (noteCategory.isEnabledOnCampaignMeeting) {
                this.noteCategories.push(noteCategory);
              }
            }
        }
          break;
      case EntityType.Booking:
        for (let i = 0; i < BookingDetailsModule.noteCategories.length; i++) {
          const noteCategory = CampaignDetailsModule.noteCategories[i];
            if (val == NoteType.General) {
              if (noteCategory.isEnabledOnBookingGeneral) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Call) {
              if (noteCategory.isEnabledOnBookingCall) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Meeting) {
              if (noteCategory.isEnabledOnBookingMeeting) {
                this.noteCategories.push(noteCategory);
              }
            }
        }
          break;
      case EntityType.Job:
        for (let i = 0; i < JobDetailsModule.noteCategories.length; i++) {
          const noteCategory = JobDetailsModule.noteCategories[i];
            if (val == NoteType.General) {
              if (noteCategory.isEnabledOnJobGeneral) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Call) {
              if (noteCategory.isEnabledOnJobCall) {
                this.noteCategories.push(noteCategory);
                continue;
              }
            } else if (val == NoteType.Meeting) {
              if (noteCategory.isEnabledOnJobMeeting) {
                this.noteCategories.push(noteCategory);
              }
            }
        }
          break;
    }
  }

  get noteTypes() {
    return ListUtils.noteTypes();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateNoteRequest();
    request.description = this.entity.description;
    request.type = this.entity.type;
    if (this.entity.noteCategory !== null) {
      request.noteCategoryId = this.entity.noteCategory.id
    }
    switch (this.entityType){
        case EntityType.Booking:
            await BookingDetailsModule.createNote(request);
            break;
        case EntityType.Job:
            await JobDetailsModule.createNote(request);
            break;
        case EntityType.Worker:
            await WorkerDetailsModule.createNote(request);
            break;
        case EntityType.Company:
            await CompanyDetailsModule.createNote(request);
            break;
        case EntityType.Contact:
            await ContactDetailsModule.createNote(request);
            break;
        case EntityType.Location:
            await LocationDetailsModule.createNote(request);
            break;
        case EntityType.Campaign:
            await CampaignDetailsModule.createNote(request);
            break;
    }
    this.dialog = false;
  }
}
